import { createRouter, createWebHashHistory } from "vue-router";
import { close, start } from "@/utils/nprogress";
import layout from "@/layouts/basic/index"
import mobileLayout from "@/layouts/mobile/index"
// 检测是否为移动端
const isMobile = localStorage.getItem('isMobile') === 'true';

// 根据设备类型设置基础路径
const baseRoute = isMobile ? '/mobile' : '';

const routes = [
  {
    path: "/",
    name: "",
    component: layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index.vue"),
      },
      {
        path: "currentSeason",
        name: "currentSeason",
        component: () => import("@/views/currentSeason/index.vue"),
      },
      {
        path: "candidates",
        name: "candidates",
        component: () => import("@/views/candidates/index.vue"),
      },
      {
        path: "recommendations",
        name: "recommendations",
        component: () => import("@/views/recommendations/index.vue"),
      },
      {
        path: "help",
        name: "help",
        component: () => import("@/views/help/index.vue"),
      },
    ]
  },
  // 移动端路由
  {
    path: "/mobile",
    name: "mobile",
    component: mobileLayout,
    redirect: "/mobile/home",
    children: [
      {
        path: "home",
        name: "mobilehome",
        component: () => import("@/views/mobile/home/index.vue"),
      },
      {
        path: "currentSeason",
        name: "mobilecurrentSeason",
        component: () => import("@/views/mobile/currentSeason/index.vue"),
      },
      {
        path: "candidates",
        name: "mobilecandidates",
        component: () => import("@/views/mobile/candidates/index.vue"),
      },
      {
        path: "recommendations",
        name: "mobilerecommendations",
        component: () => import("@/views/mobile/recommendations/index.vue"),
      },
      {
        path: "help",
        name: "mobilehelp",
        component: () => import("@/views/mobile/help/index.vue"),
      },
    ]
  },
  { name: "redirect", path: "/:catchAll(.*)", redirect: baseRoute + "/home" },
];

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes, //路由表
});
router.beforeEach((to, from, next) => {
  // 如果路由中没有year参数，但localStorage中有保存的year值，则添加到路由中 
  let savedYear = localStorage.getItem('selectedYear');
  if (!to.query.year && savedYear) {
    next({
      path: to.path,
      query: { ...to.query, year: savedYear },
      replace: true
    });
    return;
  }
  if (isMobile) {
    // 移动端处理
    if (to.path.startsWith('/mobile')) {
      // 移动端路由处理
      next();
    } else {
      // 跳转到移动端路由
      next(baseRoute + to.fullPath);
    }
  } else {
    // PC端处理
    if (to.path.startsWith('/mobile')) {
      // PC端路由处理
      next(to.fullPath.replace('/mobile', ''));
    } else {
      // 跳转到PC端路由
      next();
    }
  }
  // 如果路由中有year参数，保存到localStorage
  if (to.query.year) {
    localStorage.setItem('selectedYear', to.query.year);
  }

  next();
  start();
});

router.afterEach((pre, next) => {
  close();
});
export default router;
